import { FC } from 'react';
import { useNProgress } from '@tanem/react-nprogress';
import LoaderBar from './LoaderBar/LoaderBar';
import styles from './AppLoader.module.scss';

type Props = {
  isAnimating: boolean;
};
const AppLoader: FC<Props> = ({ isAnimating }) => {
  const { animationDuration, progress, isFinished } = useNProgress({ isAnimating });

  return (
    <>
      <div
        style={{
          display: isFinished ? 'none' : 'block',
        }}
        className={styles['app-loader']}
      />
      <LoaderBar
        newStyles={styles}
        progress={progress}
        animationDuration={animationDuration}
        isFinished={isFinished}
      />
    </>
  );
};

export default AppLoader;
